export enum LogChannel {
  Amplitude = 'Amplitude',
  Datadog = 'Datadog',
  Intercom = 'Intercom'
}
